module.exports = __webpack_public_path__ + "files/b93e8aa616e8032b36a4fc8e9dcf0da2.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-152x152.png
// module id = 747
// module chunks = 27